<template>
    <div class="commonFormStyles selectCustomer-box">
        <HeaderNav
            :header-title="text"
            left-icon-name="3"
            right-icon-name="3"
        ></HeaderNav>
        <span class="back iconfont" @click="handleBack">&#xe607;</span>
        <div class="Userlist">
            <h3>选择成员</h3>
            <div class="project-list">
                <van-radio-group v-model="checked">
                    <van-cell-group inset>
                        <template v-for="(item) in usersList">
                            <van-cell
                                clickable
                                :key="item.user_id"
                                @click="checked = item"
                            >
                                <template #title>
                                    <van-icon name="friends"></van-icon>
                                    <span class="custom-title">{{ item.user_name }}</span>
                                </template>
                                <template #right-icon>
                                    <van-radio :name="item" shape="square"></van-radio>
                                </template>
                            </van-cell>
                        </template>
                    </van-cell-group>
                </van-radio-group>
            </div>
            <div class="btns">
                <van-button
                    block
                    type="primary"
                    @click="toggle"
                >
                    确认
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
export default {
    components: {
        HeaderNav,
    },
    props: {},
    data() {
        return {
            text: '选择业务员',
            roleID: 'J01-03',
            parentPsgeName: 'newRetailAccount',
            formData: {},
            usersList: [],
            result: [],
            resultName: [],
            allCheck: false,
            checked: {},
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 通过角色编码获取指定角色下人员信息
        getUsers() {
            this.$axios
                .get(`/interfaceApi/basicplatform/roleusers/rolecode/${this.roleID}`)
                .then(res => {
                    if (res) {
                        this.usersList = res;
                    }
                }).catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 返回
        handleBack() {
            this.$router.isBack = 1;
            this.$router.replace({ name: 'newMaterialPlan',
                params: { formData: this.formData, type: 'selectSpecialRequireBack' },
            });
            this.$router.go(-1);

        },
        // 选择
        toggle() {
            if (this.roleID === 'J01-02') {
                this.formData.sales_leader_id = this.checked.user_id;
                this.formData.sales_leader_name = this.checked.user_name;
            } else {
                this.formData.salesman_id = this.checked.user_id;
                this.formData.salesman_name = this.checked.user_name;
                this.formData.salesman_phone = this.checked.mobile;
            }
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.parentPsgeName,
                params: {
                    formData: this.formData,
                    type: this.$route.params.handleType,
                    selectReturn: 'submitSelection',
                },
            });
            this.$router.go(-1);
        },

    },
    created() {
        this.roleID = this.$route.params.roleID || this.roleID;
        this.text = this.$route.params.text || this.text;
        this.parentPsgeName = this.$route.params.pageName || this.parentPsgeName;
        this.formData = this.$route.params.formData;
        this.getUsers();
    },
    mounted() {
    },
};
</script>
<style lang="stylus" scoped>
.selectCustomer-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    background: #fff
    .back
        position absolute
        top 10rpx
        left 15rpx
        z-index 10000
        color #fff
    .Userlist
        height: calc(100% - 60rpx)
        h3
            font-size 16rpx
            color #001A2C
            line-height: 46rpx
            font-weight: 500;
            font-family: SourceHanSansCN-Medium, SourceHanSansCN;
            padding: 0 14rpx
        .project-list
            height calc(100% - 46rpx)
            overflow-y auto
            overflow-x hidden
            .van-radio-group
                .van-cell-group
                    margin: 0
                    border-radius: 0
                    &:after
                        display: none
                    .van-cell
                        display: flex
                        margin-bottom: 0
                        border: 1px solid #F0F0F0;
                        .van-cell__title
                            display flex
                            align-items center
                            margin: 0
                            .van-icon
                                width 40rpx
                                height: 40rpx
                                border-radius: 50%
                                background: #167EF8
                                color #fff
                                font-size 20rpx
                                line-height: 40rpx
                                text-align: center
                                margin-right: 10rpx
                            .custom-title
                                font-size 14rpx
        .btns
            height 60rpx
            padding 0 5rpx
            display flex
            align-items center
            justify-content center
            background #FFFFFF
            box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.2);
            position: relative
            z-index 2
            button
                flex 1
                width 160rpx
                height 40rpx
                background: #0078FB
                border-radius: 2px;
                font-size 14rpx
                position relative
                color #fff
                margin 0 10rpx
                border-color #0078FB
</style>
